// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"a165a695","453":"437301e1","571":"f1aac9d3"}[chunkId] + ".chunk.js";
};